import getPersonaBlobFetchStatus from '../selectors/getPersonaBlobFetchStatus';
import { PersonaBlobFetchStatus } from '../store/schema/PersonaBlob';

const shouldFetchPersonaPhoto = (personaControlKey): boolean =>
    getPersonaBlobFetchStatus(personaControlKey) === PersonaBlobFetchStatus.None;

export default shouldFetchPersonaPhoto;
